import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import app from '../utils/firebase';
import { setDoc, serverTimestamp } from 'firebase/firestore';
import { Paths } from '../repositories/firestoreUtils';
import { getAuth } from 'firebase/auth';

export async function registerPush(swPath: string = '/firebase-messaging-sw.js'): Promise<string | null> {
  try {
    if (!(await isSupported())) return null;
    if ('serviceWorker' in navigator) {
      try { await navigator.serviceWorker.register(swPath); } catch {}
    }
    const messaging = getMessaging(app);
    // VAPID key should be configured via env; fallback to none (token may fail if missing)
    const vapidKey = (process.env.REACT_APP_FCM_VAPID_KEY || '').trim() || undefined;
    const token = await getToken(messaging, { vapidKey }).catch(() => null);
    const uid = getAuth().currentUser?.uid || null;
    if (token && uid) {
      await setDoc(Paths.userDeviceTokenDoc(uid, token), { created_at: serverTimestamp(), last_seen: serverTimestamp(), ua: navigator.userAgent }, { merge: true });
    }
    // Listen for foreground messages to optionally surface toast/badge
    try { onMessage(messaging, () => {}); } catch {}
    return token;
  } catch {
    return null;
  }
}

export default { registerPush };

export {};
